module.exports = "/static/assets/7fab4344ee6c8c4dbc448efba64cb49a.png";